export const QUICK_INSIGHT_PROMPTS: Record<string, Record<string, string>> = {
  call: {
    responding_personas:
      "Analyze which personas and job titles are picking up our cold calls the most. Break down connect rates by job title, industry, and company size. Who should we be targeting?",
    effective_messaging:
      "Based on our call analysis data, what messaging strategies and conversation approaches are working best? Look at sentiment, golden nuggets, and successful call patterns.",
    optimal_timing:
      "Analyze our call timing patterns. What are the best days of the week and hours of the day to call based on connect rates? What times should we avoid? Show data in a table.",
    rep_rankings:
      "Rank our sales reps by performance. Compare their dial counts, connect rates, meetings booked, and opportunities created. Who are the top performers and who needs coaching?",
    effective_openers:
      "From our call analysis data — golden nuggets, opening hooks, and successful conversations — what cold call openers and conversation starters are proving most effective?",
    quick_wins:
      "Identify the top 3-5 quick wins we can implement this week to improve our cold calling results. Focus on actionable, specific improvements based on the data.",
  },
  email: {
    responding_personas:
      "Analyze our email engagement data. Which recipients are opening and replying to our emails the most? What patterns do you see in engagement by persona?",
    effective_messaging:
      "Based on our email metrics — open rates, click rates, and reply rates — what messaging patterns are working? What can we improve?",
    optimal_timing:
      "Analyze email send timing patterns. When are we getting the best open and reply rates? What days and times should we prioritize for email outreach?",
    rep_rankings:
      "Compare our team's email outreach performance. Who has the best open rates, reply rates, and meeting conversion from email?",
    effective_openers:
      "What email subject lines and opening lines are driving the highest engagement? Analyze patterns in our most successful email outreach.",
    quick_wins:
      "Identify the top 3-5 quick wins to improve our email outreach performance this week. Focus on actionable changes based on current metrics.",
  },
  linkedin: {
    responding_personas:
      "Analyze our LinkedIn engagement data. Which personas are accepting connections and responding to messages? What patterns do you see?",
    effective_messaging:
      "Based on our LinkedIn metrics — connection acceptance, message replies, and engagement — what messaging approaches are working best?",
    optimal_timing:
      "Analyze LinkedIn outreach timing. When are we getting the best response rates? What days and times should we focus our LinkedIn activity?",
    rep_rankings:
      "Compare our team's LinkedIn outreach performance. Who is generating the most connections, replies, and meetings from LinkedIn?",
    effective_openers:
      "What LinkedIn connection messages and InMail approaches are getting the best acceptance and reply rates?",
    quick_wins:
      "Identify the top 3-5 quick wins to improve our LinkedIn outreach results this week. Focus on specific, actionable improvements.",
  },
};
